/**
 * Normalize lesson / word text before TTS (English or Russian side from // pairs).
 */
export function cleanTextForTts(text, lang = "en-US") {
  if (!text || typeof text !== "string") return "";

  let cleaned = text;

  // Bilingual "english // russian" — require spaces so URLs (https://) are not split.
  if (/\s\/\/\s/.test(cleaned)) {
    const parts = cleaned.split(/\s\/\/\s/);
    cleaned = lang === "en-US" ? parts[0] : parts[1] || parts[0];
  }

  cleaned = cleaned.replace(/<[^>]*>/g, "");
  cleaned = cleaned.replace(/!\[([^\]]*)\]\([^)]*\)/g, "$1");
  cleaned = cleaned.replace(/\[([^\]]+)\]\([^)]*\)/g, "$1");
  cleaned = cleaned.replace(/\[(.*?)\/.*?\]/g, "$1");
  cleaned = cleaned.replace(/\[(.*?)\]/g, "$1");
  cleaned = cleaned.replace(/`([^`]+)`/g, "$1");
  cleaned = cleaned.replace(/\*\*([^*]+)\*\*/g, "$1");
  cleaned = cleaned.replace(/\*([^*]+)\*/g, "$1");
  cleaned = cleaned.replace(/__([^_]+)__/g, "$1");
  cleaned = cleaned.replace(/_([^_]+)_/g, "$1");
  cleaned = cleaned.replace(/\|\|/g, "");
  cleaned = cleaned.replace(/https?:\/\/\S+/gi, "");
  // Typographic quotes → ASCII (Word/Docs paste; keeps Piper / browser TTS happy)
  cleaned = cleaned.replace(/[\u2018\u2019\u201A\u2032]/g, "'");
  cleaned = cleaned.replace(/[\u201C\u201D\u201E\u2033]/g, '"');
  cleaned = cleaned.replace(/\u00A0/g, " ");
  cleaned = cleaned.replace(/\s*[/#*_~|`[\]>\\]+\s*/g, " ");

  return cleaned.replace(/\s+/g, " ").trim();
}
